import React, { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { familyMemberTexts, productType, RECIPIENT_TYPES , messageData} from '../Conatant';
import { AssignBenefitsToOrgFamilyMember, updateDraftAllocation, setMessageData } from '../OrganizationEmployeeSlice';
import BtnNextStep from '../BtnNextStep';
import plusIcon from '../icons/plus.svg';
import minusIcon from '../icons/minus.svg';

const getAssignedProducts = (allocations = {}) =>
  Object.keys(allocations).filter((key) => Number(allocations[key]) > 0);

const getRemainingBeforeDraft = (quantities, members) =>
  Object.keys(quantities || {}).reduce((acc, key) => {
    const usedBySent = (members || []).reduce((sum, member) => sum + (Number(member.allocations?.[key]) || 0), 0);
    acc[key] = Math.max(0, quantities[key].quantity - usedBySent);
    return acc;
  }, {});


function AllocationStep(props) {

  const { productsDescription, familyMembers, selectedBenefits, recipientType, draftMember, OrganizationEmployee } = props;
  const [allocationError, setAllocationError] = useState('');
  const [recipientObject, setRecipientObject] = useState(recipientType === RECIPIENT_TYPES.SELF ? OrganizationEmployee : draftMember);

  const existingMember = useMemo(
    () => {
      return (familyMembers || []).find((member) => member.phoneNumber === recipientObject?.phoneNumber) || null;
    },
    [familyMembers, recipientObject],
  );

  const existingAllocations = existingMember?.allocations || {};
  const existingProducts = useMemo(() => getAssignedProducts(existingAllocations), [existingAllocations]);

  const remainingBeforeDraft = useMemo(
    () => getRemainingBeforeDraft(productsDescription, familyMembers),
    [productsDescription, familyMembers],
  );

  const remaining = useMemo(() => {
    return Object.keys(remainingBeforeDraft).reduce((acc, key) => {
      const usedByDraft = Number(draftMember?.allocations?.[key]) || 0;
      acc[key] = Math.max(0, productsDescription[key].remaining - usedByDraft);
      return acc;
    }, {});
  }, [remainingBeforeDraft, draftMember]);

  const recipientDisplayName = useMemo(() => {

    return `${recipientObject?.firstName} ${recipientObject?.lastName}, ${recipientObject?.phoneNumber}`;
  }, [recipientObject]);




  
  const buildNewProductQuantities = (draftAllocations = {}, selectedBenefits = []) => {
    const productQuantities = {};
  
    selectedBenefits.forEach((key) => {
      const draftQty = Number(draftAllocations[key]) || 0;
      if (draftQty > 0) {
        productQuantities[key] = draftQty;
      }
    });
  
    return productQuantities;
  };

  const handleAllocationChange = (productKey, nextValue) => {
    props.updateDraftAllocation({ productKey, value: nextValue });
    setAllocationError('');
  };

  const buildRequest = () => {
    const productQuantities = buildNewProductQuantities(
      draftMember?.allocations,
      selectedBenefits,
    );

  
    return {
      familyMembers: [
        {
           firstName:  recipientObject.firstName,
          lastName: recipientObject.lastName,
          phoneNumber: recipientObject.phoneNumber,
          productQuantities,
        },
      ],
    };

  };

  const handleContinue = async () => {
    const hasNewAllocation = selectedBenefits.some((key) => Number(draftMember?.allocations?.[key]) > 0);
    if (!hasNewAllocation) {
      setAllocationError(familyMemberTexts.errors.noAllocation);
      return false;
    }
    setAllocationError('');
    var params = buildRequest();
    props.setMessageData({...messageData.BenefitsSentConfirmation, params: params});
    return true;
  };


  return (
    <>

      <div className={`${props.className} allocation-step`}>
        {recipientDisplayName && <div className='recipient-banner'>{recipientDisplayName}</div>}
        <div className='allocation-cards'>
          {selectedBenefits.map((key) => {

            const title = `הטבת ${ productsDescription[key].name}`;
            const description = productsDescription[key].description;
            const current = Number(draftMember?.allocations?.[key]) || 0;
            const availableTotal = productsDescription[key].remaining;
            const canIncrease = remaining[key] > 0;

            return (
              <div className='allocation-card' key={key}>
                <div className='allocation-card-info'>
                  <span className='allocation-card-title'>{title}</span>
                  <div className='allocation-card-description'>
                    {description && <span className='allocation-text'>{description}</span>}
                    <div className='allocation-card-controls'>
                      <div className='stepper'>
                        <div
                          className={`stepper-btn ${!canIncrease ? 'disabled' : ''}`}
                          onClick={() => handleAllocationChange(key, current + 1)} >
                          <img src={plusIcon} alt='הוספה' />
                        </div>
                        <span className='stepper-value'>{current}</span>
                          <div
                            className={`stepper-btn ${current <= 0 ? 'disabled' : ''}`}
                            onClick={() => handleAllocationChange(key, current - 1)}>
                          <img src={minusIcon} alt='הסרה' />
                        </div>

                      </div>

                      <span className='allocation-card-quota'>
                        {familyMemberTexts.allocation.outOfRedeem.replace('{count}', availableTotal)}
                      </span>
                    </div>
                  </div>
                </div>

              </div>
            );
          })}
        </div>
        {existingProducts.length > 0 && (
          <div className='existing-allocations'>
            <span className='existing-allocations-title'>{familyMemberTexts.allocation.existingTitle}</span>
            <div className='allocation-cards existing'>
              {existingProducts.map((key) => {
                const title = `הטבת ${ productsDescription[key].name ? productsDescription[key].name : productType[key]}`;
                const description = productsDescription[key].description;
                const quantity = Number(existingAllocations[key]) || 0;
                return (
                  <div className='allocation-card existing-card' key={`existing-${key}`}>
                    <div className='allocation-card-info'>
                      <span className='allocation-card-title'>{title}</span>
                      {description && <span className='allocation-card-description'>{description}</span>}
                    </div>
                    <div className='allocation-card-controls'>
                      <span className='existing-quantity'>
                        {familyMemberTexts.allocation.existingQuantity.replace('{count}', quantity)}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
      <BtnNextStep
        text={familyMemberTexts.allocation.continueAndSend}
        onclick={handleContinue}
        errorText={allocationError}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  productsDescription: state.organizationEmployee.productsDescription,
  familyMembers: state.organizationEmployee.familyMembers,
  selectedBenefits: state.organizationEmployee.selectedBenefits,
  recipientType: state.organizationEmployee.recipientType,
  draftMember: state.organizationEmployee.draftMember,
  OrganizationEmployee: {
      firstName: state.authentication.loginData.userDetails.OrganizationEmployee.EmployeeFirstName, 
      lastName: state.authentication.loginData.userDetails.OrganizationEmployee.EmployeeLastName,
     phoneNumber: state.authentication.loginData.userDetails.OrganizationEmployee.EmployeePhone},
});

const mapDispatchToProps = {
  updateDraftAllocation,
  AssignBenefitsToOrgFamilyMember,
  setMessageData,
};

export default connect(mapStateToProps, mapDispatchToProps)(AllocationStep);
